var hostPath = process.env.VUE_APP_URL_SCENARIO_API;
var assetPath = "/resources/scenarios/assets/"

var setup = {
    hostPath: hostPath,
    assetPath: assetPath
};

export default setup;